import { render } from "./app-header-account-sets.vue?vue&type=template&id=6336ec54"
import script from "./app-header-account-sets.vue?vue&type=script&lang=js"
export * from "./app-header-account-sets.vue?vue&type=script&lang=js"

import "./app-header-account-sets.vue?vue&type=style&index=0&id=6336ec54&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__